import envVar from '../config/envVars';
import { RollNoData } from '../modules/RollNoUpdate/types/rollNoDataType';
import httpPost from './httpClient/httpPost';
import httpPut from './httpClient/httpPut';

export interface Filters {
  selectedColumns: string[];
  grade: string;
  division: string;
}

const fetchStudentRollNoApi = async (
  filter: Filters,
  page: number,
  perPage: number
) => {
  return httpPost(
    `${envVar.REACT_APP_BASE_API_URL}/reports/student?page=${page}&perPage=${perPage}&sortByRollNo=${true}`,
    filter
  );
};

const updateStudentRollNoApi = async (
  rollNoToUpdate: Partial<RollNoData>[]
) => {
  return httpPut(`${envVar.REACT_APP_BASE_API_URL}/students/roll-number`, {
    rollNumberUpdateRequest: rollNoToUpdate
  });
};

export { fetchStudentRollNoApi, updateStudentRollNoApi };
